import * as React from "react";
import PropTypes from "prop-types";
import { IconInfo } from "../../../Icons";
import Dialog from "../../../Dialog";
import Button from "../../../Button";

const styles = {
  infoButton: {
    padding: "0",
    borderRadius: "50%",
    backgroundColor: "transparent",
    color: "inherit",
  },
  dialogContainer: {
    margin: "1em",
    minWidth: "10em",
    maxWidth: "80vw",
    overflow: "hidden",
  },
  dialogButton: {
    textAlign: "center",
    marginTop: "1em",
    marginLeft: "1em",
    marginRight: "1em",
  },
};

export default class InfoIcon extends React.Component {
  static propTypes = {
    dialogText: PropTypes.string,
  };

  state = {
    open: false,
  };

  _toggleOpen = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  render() {
    const { dialogText } = this.props;
    const { open } = this.state;

    return (
      <React.Fragment>
        <Button
          aria-label="Field info"
          onTap={this._toggleOpen}
          style={styles.infoButton}
        >
          <IconInfo />
        </Button>
        <Dialog
          open={open}
          onTapBackground={this._toggleOpen}
          onRequestClose={this._toggleOpen}
        >
          <div style={styles.dialogContainer}>
            {dialogText}
            <div style={styles.dialogButton}>
              <Button onTap={this._toggleOpen}>Ok</Button>
            </div>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/FormFieldIcons/InfoIcon.jsx